import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Section from "../components/section/Section";
import Grid from "../components/grid/Grid";
import Layout from "../components/layout/Layout";
import FeatureSection from "../components/feature-section/FeatureSection";
import ArticleCard from "../components/article-card/ArticleCard";
import ButtonLink from "../components/links/ButtonLink";
import cssClass from "./index.module.scss";

const Index = ({ data }) => {
  const {
    titleFirstLine,
    titleSecondLine,
    introduction,
    callToAction,
    journeyTitle,
    journeyContent,
    journeyArticles,
    findClinicTitle,
    findClinicContent,
    findClinicImage,
    findYourClinicCallToAction,
    clinicExpertiseTitle,
    clinicExpertiseProofPoints,
    registerInterestTitle,
    registerInterestContent,
    registerInterestImage,
    registerInterestCallToAction,
  } = data.contentfulHomePage;

  return (
    <Layout>
      <Section className={cssClass.hero}>
        <Grid>
          <div className={cssClass.heroContent}>
            <h1>
              {titleFirstLine}
              <br />
              {titleSecondLine}
            </h1>
            <div
              dangerouslySetInnerHTML={{
                __html: introduction.childMarkdownRemark.html,
              }}
            />
          </div>
          <ButtonLink to="/" className={cssClass.journeyButton}>
            {callToAction}
          </ButtonLink>
        </Grid>
      </Section>
      <Section bottomVerticalPadding>
        <div className={cssClass.journeyText}>
          <h2 className={cssClass.journeyTitle}>{journeyTitle}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: journeyContent.childMarkdownRemark.html,
            }}
          />
        </div>
        {journeyArticles && (
          <Grid columns={3}>
            {journeyArticles.map((article, i) => {
              return (
                <ArticleCard
                  key={article.id}
                  {...article}
                  isRowLayout={i > 3}
                  smallImage
                />
              );
            })}
          </Grid>
        )}
      </Section>
      <FeatureSection image={findClinicImage}>
        <h1>{findClinicTitle}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: findClinicContent.childMarkdownRemark.html,
          }}
          className={cssClass.findClinicText}
        />
        <ButtonLink to="/find-your-clinic" alternativeInvert>
          {findYourClinicCallToAction}
        </ButtonLink>
      </FeatureSection>
      <Section verticalPadding>
        <h2 className={cssClass.clinicExpertiseTitle}>
          {clinicExpertiseTitle}
        </h2>
        {clinicExpertiseProofPoints && (
          <Grid columns={3}>
            {clinicExpertiseProofPoints.map((item) => {
              return (
                <div key={item.id}>
                  <div className={cssClass.proofImageWrapper}>
                    <Img fluid={item.image.fluid} alt={item.image.title} />
                  </div>
                  <h3 className={cssClass.proofTitle}>{item.name}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.body.childMarkdownRemark.html,
                    }}
                    className={cssClass.proofContent}
                  />
                </div>
              );
            })}
          </Grid>
        )}
      </Section>
      <Section className={cssClass.registerInterest}>
        <div className={cssClass.registerInterestImage}>
          <Img
            fluid={registerInterestImage.fluid}
            alt={registerInterestImage.title}
          />
        </div>
        <div className={cssClass.registerInterestContent}>
          <h2 className={cssClass.registerInterestTitle}>
            {registerInterestTitle}
          </h2>
          <div
            dangerouslySetInnerHTML={{
              __html: registerInterestContent.childMarkdownRemark.html,
            }}
            className={cssClass.registerInterestText}
          />
          <ButtonLink to="/" className={cssClass.registerInterestButton}>
            {registerInterestCallToAction}
          </ButtonLink>
        </div>
      </Section>
    </Layout>
  );
};

export default Index;

export const query = graphql`
  query IndexContent($locale: String) {
    contentfulHomePage(node_locale: { eq: $locale }) {
      titleFirstLine
      titleSecondLine
      introduction {
        childMarkdownRemark {
          html
        }
      }
      callToAction
      journeyTitle
      journeyContent {
        childMarkdownRemark {
          html
        }
      }
      journeyArticles {
        id
        name
        thumbnail {
          title
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        slug
        topic {
          name
          slug
        }
      }
      findClinicTitle
      findClinicContent {
        childMarkdownRemark {
          html
        }
      }
      findClinicImage {
        title
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      findYourClinicCallToAction
      clinicExpertiseTitle
      clinicExpertiseProofPoints {
        id
        name
        body {
          childMarkdownRemark {
            html
          }
        }
        image {
          title
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
      registerInterestTitle
      registerInterestContent {
        childMarkdownRemark {
          html
        }
      }
      registerInterestImage {
        title
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      registerInterestCallToAction
    }
  }
`;
